import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import { AUTHORIZATION } from '@/core/config/userConfig.js'
// import { deepCopy } from "@/util/index.js";
// let Base64 = require('js-base64').Base64;
// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const MENUS = "headerMenus";
export const GET_USER = 'getUser';
export const CHANGE_MENUS = "changeMenus";
export const MODIFY_PW = "modify_password";
// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";
export const SET_MENUS = "setHeaderMenus";
export const SET_USER = "setUserInfo";
export const SET_CHANGE_MENUS = "setChangeMenus";

const MENU = [{
  name: "系统管理",
  component: "userPage/userPageMain",
  url: 'system',
  icon: "compass-fill",
  children: [{
    component: 'userPage/system/application',
    name: '应用管理',
    id: 'a3',
    url: 'application'
  }, {
    component: 'userPage/system/menuManager/menuManager',
    name: '菜单管理',
    id: 'a2',
    url: 'menuManager'
  }, {
    component: 'userPage/system/user',
    name: '用户管理',
    id: 'a221',
    url: 'user'
  }, {
    component: 'userPage/system/roleManager',
    name: '角色管理',
    id: 'a222',
    url: 'roleManager'
  }],
  id: 'a1'
},{
  name: "人事档案管理系统",
  id: 'personal',
  component: "userPage/personalFile/personal",
  url: 'personal',
  icon: "compass-fill",
  children: [{
    component: 'userPage/personalFile/personalPage/personalPage',
    name: '人事档案管理',
    id: 'personal1',
    url: 'personalPage'
  },{
    component: 'userPage/personalFile/personalPage/fields',
    name: '字段管理',
    id: 'fields',
    url: 'fields'
  },{
    component: 'userPage/personalFile/personalPage/print',
    name: '打印模板管理',
    id: 'print',
    url: 'print'
  },{
    component: 'userPage/personalFile/personalPage/report',
    name: '报表管理',
    id: 'report',
    url: 'report'
  },{
    component: 'userPage/personalFile/personalPage/search',
    name: '查询条件管理',
    id: 'search',
    url: 'search'
  },{
    component: 'userPage/personalFile/personalPage/dictionary',
    name: '字典管理',
    id: 'dictionary',
    url: 'dictionary'
  }]
}
]
const state = {
  headerMenus: [],
  routers: [],
  userInfo: {},
  errors: '',
  user: {},
  leftMenu: [],
  isAuthenticated: !!JwtService.getToken(),
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

const actions = {
  // [CHANGE_MENUS]({ commit }) {
  //   commit(SET_CHANGE_MENUS, MENU);
  //   return MENU;
  // },
  [MODIFY_PW]({ commit }, { oldPassword, newPassword }) {
    console.log(commit);
    return ApiService.put(`/api-user/users/password`, {
      oldPassword,
      newPassword
    });
  },
  [CHANGE_MENUS]({ commit }, clientId) {
    return ApiService.get(`/api-user/menus/change/current?clientId=${clientId}`).then((data) => {
      data.push(...MENU);
      commit(SET_CHANGE_MENUS, data);
      return data
    })
  },
  [GET_USER]({ commit }) {
    return ApiService.get('/api-user/users/current').then((data) => {
      commit(SET_USER, data);
      return data
    })
  },
  [MENUS]({ commit }) {
    return ApiService.get(`/api-user/menus/app/current`).then((data) => {
      commit(SET_MENUS, data);
      return data;
    })
  },
  [LOGIN]({ commit }, credentials) {
    return ApiService.post(`/api-uaa/oauth/token`,
      {
        grant_type: 'password',
        username: credentials.username,
        password: credentials.password
      }, {
      headers: { Authorization: AUTHORIZATION }
    }).
      then((data) => {
        commit(SET_AUTH, data);
      })
  },
  [LOGOUT]({ commit }) {
    ApiService.post('/api-uaa/oauth/remove/token', {
      access_token: JwtService.getToken(),
    })
    commit(PURGE_AUTH);
  },
  [REGISTER](context, credentials) {
    return new Promise((resolve, reject) => {

      ApiService.post("users", { user: credentials })
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
          reject(response);
        });
    });
  },
  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.get("verify")
        .then(({ data }) => {

          context.commit(SET_AUTH, data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    } else {
      context.commit(PURGE_AUTH);
    }
  },
  [UPDATE_USER](context, payload) {
    const { email, username, password, image, bio } = payload;
    const user = { email, username, bio, image };
    if (password) {
      user.password = password;
    }

    return ApiService.put("user", user).then(({ data }) => {

      context.commit(SET_AUTH, data);
      return data;
    });
  }
};

const mutations = {
  [SET_CHANGE_MENUS](state, leftMenu) {
    state.leftMenu = leftMenu;
  },
  [SET_USER](state, user) {
    state.userInfo = user;
  },
  [SET_MENUS](state, menu) {
    state.headerMenus = menu;
  },
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {

    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    JwtService.saveToken(state.user.access_token);
    JwtService.saveRefreshToken(state.user.refresh_token);
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.userInfo = {};
    state.errors = {};
    state.headerMenus = [];
    state.leftMenu = [];
    state.routers = [];
    JwtService.destroyToken();
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
